import React from "react";
// Librerías y estilos globales
import { Routes, Route, Navigate } from "react-router-dom";
import GlobalStyle from "./constants/globalStyles";
// Home y Pasos
import InicioPage from "./pages/inicio-page";
import PasosPage from "./pages/pasos-page";

function App() {
  return (
    <div className="App">
      <Routes>
        {/* ------------------ Home y Pasos ------------------ */}

        {/* Inicio */}
        <Route exact path="/" element={<InicioPage />} />
        {/* Pasos */}
        <Route exact path="/pasos" element={<PasosPage />} />

        <Route exact path="/asap-consulting" element={<InicioPage />} />

        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
      <GlobalStyle></GlobalStyle>
    </div>
  );
}

export default App;
